<template>
  <div>
    <v-date-range-picker
      :vModel="range"
      v-model="range"
      label="Select Date Range"
    ></v-date-range-picker>
    <d-table
      v-if="tableReady"
      :data_object="data_object"
      :getFreshData="true"
      :searchableColumns="searchableColumns"
      :linkClick="linkClick"
      :link="link"
      :itemsPerPage="15"
      :hasSearch="true"
      ref="dTable"
      :key="tableKey"
      :serverPagination="false"
      :showGroupBy="false"
      :sortBy="sortBy"
      :insertable="false"
      :editRow="true"
      :noCache="true"
      :addButtonCaption="addButtonCaption"
      :alwaysUpdate="true"
      :onDataReceived="onDataReceived"
      :editedItemTitle="editedItemTitle"
      tableName="payroll"
      :columnTool="true"
      :defaultModel="defaultModel"
      :scrollableEditor="true"
      :aggregate="aggregate"
    />
  </div>
</template>

<script>
import { watch } from "vue";
import * as fun from "../plugins/common";
export default {
  name: "Payroll",
  components: {
    DTable: () => import("../components/Table.vue"),
    VDateRangePicker: () => import("../components/DateRangePicker.vue"),
  },
  props: {},
  data() {
    return {
      tableKey: 0,
      tableReady: false,
      getFreshData: true,
      type: "",
      range: "",
      qry: null,

      data_object: {
        object_name: "payroll",
        // schema_name: "employee",
        // object_name_to_update: "employee",
        // delete_object_name: "employee",

        table_title: "Payroll",
        all_records: true,
        editRow: true,
        // pipeline_date_fields: ["payroll_date_obj"],
      },
      editedItemTitle: ["contact.full_name"],
      searchableColumns: [],
      // sortBy: "contact.full_name",

      addButtonCaption: "Add Payroll",
    };
  },
  mounted() {
    this.range = fun.getCurrentWeekRange();
    this.getQry();
    this.tableReady = true;
  },

  methods: {
    getQry() {
      const [startStr, endStr] = this.range.split(" - ");

      var monday = new Date(startStr);
      monday.setHours(0, 0, 0, 0);

      var sunday = new Date(endStr);
      sunday.setHours(23, 59, 59, 999);

      this.data_object.pipeline = [
        {
          $addFields: {
            payroll_date_obj: {
              $dateFromString: {
                dateString: "$payroll_date",
                timezone: "UTC",
                // format: "%m/%d/%Y", // adjust to your format
              },
            },
          },
        },
        {
          $match: {
            payroll_date_obj: {
              $gte: `ISODate("${fun.formatDate(monday, true)}T00:00:00.000Z")`,
              $lte: `ISODate("${fun.formatDate(sunday, true)}T00:00:00.000Z")`,
            },
          },
        },
      ];
      // $gte: `ISODate("${dateFilter.$gte}T00:00:00.000Z")`,
      // $lt: `ISODate("${dateFilter.$lt}T00:00:00.000Z")`,
      // this.qry = {
      //   payroll_date: {
      //     $gte: monday,
      //     $lte: sunday,
      //   },
      // };
    },
    onDataReceived(d) {
      // d.schema.properties.category.default_value = this.type + "_employee";
      d.schema["v-bind"].toolBarControls.splice(1, 1);
      var calControl = {
        comp: "v-date-range",
        id: "payroll_period",
        default: true,
        // "v-bind": {
        //   color: "info",
        //   text: true,
        //   icon: "mdi-calculator",
        //   "input-value": "Calculate Payroll",
        // },
      };
      d.schema["v-bind"].toolBarControls.push(calControl);
      return d;
    },
  },
  computed: {
    // currentWeek() {
    //   return fun.getCurrentWeekRange();
    // },
  },
  watch: {
    range() {
      this.getQry();
      this.tableKey = !this.tableKey;
    },
  },
};
</script>

<style lang="css" scoped></style>
